import * as React from 'react';
import { CodeComparison } from '@ui/general';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { Card, Row } from 'antd';
import { TimelineChangeDetails, TimelineTableEntry } from '@sonar-software/sonar-core';

interface ChangeRecordsProps {
	record: TimelineTableEntry;
}

class ChangeRecords extends React.Component<ChangeRecordsProps> {
	renderChangeCard = (record: TimelineTableEntry): React.ReactNode => {
		const { changeDetail, id } = record.change;

		return (
			<Card
				className='change'
				key={ id }>
				<Row>{ changeDetail && this.renderDetail(changeDetail) }</Row>

				{ this.renderCodeComparison(record.change) }
			</Card>
		);
	};

	renderCodeComparison = (change: TimelineChangeDetails): React.ReactNode => {
		const { id, newValue, oldValue } = change;

		if (newValue || oldValue) {
			return (
				<CodeComparison
					key={ id }
					newCode={ newValue ?? COPY_SPECIFIC.NONE_PARENTHETICAL }
					oldCode={ oldValue ?? COPY_SPECIFIC.NONE_PARENTHETICAL } />
			);
		}

		return false;
	};

	renderDetail = (changeDetail: string): React.ReactNode =>
		<div className='diff'>
			<span className='label'>{ COPY_SPECIFIC.CHANGE_DETAIL }</span>
			<span className='value'>{ changeDetail }</span>
		</div>;

	render(): React.ReactNode {
		const { record } = this.props;

		return <div className='modifications'>{ this.renderChangeCard(record) }</div>;
	}
}

export default ChangeRecords;
